/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA
 */

import moment from 'moment';
import {
    DATE_FORMAT_KEYS,
    resolveDisplayFormat,
    resolveFormatByKey,
    getDateFormatLocale,
    formatEpochSync
} from '@oat-sa-private/ui-core';

export {
    DATE_FORMAT_KEYS,
    resolveDisplayFormat,
    resolveFormatByKey,
    getDateFormatLocale
};

export const formatEpoch = formatEpochSync;

/**
 * Formats a moment-parsable value as a localized datetime string.
 * @param {string|number|Date} value
 * @returns {string}
 */
export function formatMomentDatetime(value) {
    return formatEpoch({
        epoch: moment(value).valueOf(),
        hasHour: true,
        isUnixMsTime: true
    });
}
